<template>
  <header id="header">
    <b-container class="py-1">
      <b-row
        align-h="between"
        align-v="center"
      >
        <b-col md="5">
          <h1>
            <router-link
              :to="`/${$t('lang')}/`"
              class="align-items-center justify-content-center justify-content-md-start"
            >
              <img
                alt=""
                class="mr-4"
                :src="`${$t('baseurl')}img/icons/apple-touch-icon.png`"
              />
              <span
                class="h3 m-0"
                v-html="`${$t('meta.title')} ${$t('color.soft')}`"
              ></span>
            </router-link>
          </h1>
        </b-col>
        <b-col
          md="7"
          class="px-0"
        >
          <Menu />
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
import Menu from './Menu.vue';

export default {
  components: {
    Menu,
  },
};
</script>

